import type { Grinder, Shot } from "../engine/model";

/**
 * Shots the predictor may use on a grinder: everything pulled at or after its `calibratedSince` (all shots when the
 * grinder was never recalibrated). Earlier shots stay stored and visible in history; they just stop influencing
 * predictions, x_ref and learning. Timestamps are fixed-width ISO, so string comparison is chronological.
 */
export function activeShots<T extends Shot>(shots: readonly T[], g: Grinder): T[] {
  const since = g.calibratedSince;
  return since === null ? [...shots] : shots.filter((s) => s.timestamp >= since);
}

/** True when a shot predates the grinder's recalibration. */
export function isBeforeCalibration(s: Shot, g: Grinder | null): boolean {
  return g !== null && g.calibratedSince !== null && s.timestamp < g.calibratedSince;
}
